<template>
    <div id="page-heading" v-if="pageTitle">
        <div class="columns is-desktop">
            <div class="column">
                <div class="heading-left">
                    <h1 class="title">{{ pageTitle }}</h1>
                </div>
            </div>
            <div class="column">
                <div class="heading-right" v-if="authUser">
                    <div v-if="showTourButton" class="help-issue is-right pull-right">
                        <a href="#" v-on:click.prevent="startTour"
                           class="toggle-help">
                            <b-icon icon="life-ring" size="is-small"></b-icon>
                            <span class="help-label">View Tour</span>
                        </a>
                    </div>
                    <help v-if="userCan('view_help_request', 'init')" />
                    <div v-if="showPureChat" class="help-issue is-right pull-right" aria-label="help">
                        <a href="#" v-on:click.prevent="openPureChat"
                           class="toggle-help purechat-button-expand">
                            <b-icon icon="comment-alt" size="is-small"></b-icon>
                            <span class="help-label">Live Chat</span>
                        </a>
                    </div>
                    <div id="notifications-button">
                      <notifications />
                    </div>
                </div>
                <invited-title v-if="authUser && authUser.via_invite"></invited-title>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Notifications from './Notifications'
import Help from './Help'
import InvitedTitle from './InvitedTitle'

export default {
  name: 'Header',
  components: {
    Notifications,
    Help,
    InvitedTitle
  },
  methods: {
    openPureChat () {
      if (!this.showPureChat) return
      window.open(process.env.PURECHAT + '&origin=' + encodeURI(window.location.href), 'purechat', 'width=425, height=700')
    },
    startTour () {
      this.$store.commit('setAccountActiveTab', {
        'account_id': this.$router.currentRoute.params.id,
        'tab': 0
      })
      this.$store.commit('showTourModal')
    }
  },
  computed: {
    ...mapState([
      'pageTitle'
    ]),
    ...mapGetters({
      authUser: 'authUser',
      userCan: 'userCan',
      userRole: 'userRole'
    }),
    showPureChat () {
      if (!process.env.PURECHAT) return false
      return true
    },
    showTourButton () {
      let show = false
      if ((this.authUser.via_invite || this.authUser.via_share_link) && this.$route.name === 'account-dashboard') {
        show = true
      }

      if (this.userRole('upload_only')) {
        show = false
      }

      return show
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/Heading.vue